import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=1f17069a&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=1f17069a&scoped=true&lang=scss&"
import style1 from "./checkbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17069a",
  null
  
)

export default component.exports